var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("企业微信侧边栏项目首页")]),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.goForm}},[_vm._v("模拟跳转表单页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }